import GoogleMapsLoader from '../lib/simple-map.js';

function handleSelect(elm)
{
	window.location = elm.value;
}

wwdev.Bootstrap.appartments = function(){
	var backside = false;
	jQuery('.toggle-backside-button').click(function() {
		jQuery('.contentelement-appertments-map .front, .contentelement-appertments-map .back').toggleClass('active');
		if(backside) {
			jQuery(this).text( "Bekijk de voorzijde" );
			backside = false;
		}
		else {
			jQuery(this).text( "Bekijk de zijkant" );
			backside = true;
		}
	});
};

wwdev.Bootstrap.run = function() {
	this._run();
	this.initBxSlider({
		selector: '.slider ul',
		auto : false,
		autoStart : false,
	});
	this.initBxSlider({
		selector: '.bxslider',
		pagerCustom: '#bx-pager',
		pager: true,
		auto : false,
		autoStart : false,
		prevText: '',
		nextText: ''
	});
	this.appartments();

	jQuery('.js-whatsapp-open').on('click', function() {
		jQuery('.whatsapp-box').toggle();
		return false;
	});

	jQuery('a.model-show').click(function() {
		if (jQuery(this).find('.model-text').length > 0) {
			var modelText = jQuery(this).find('.model-text');
		} else if (jQuery(this).parents('div:first').find('.model-text').length > 0) {
			var modelText = jQuery(this).parents('div:first').find('.model-text');
		}
		if (typeof modelText != 'undefined') {
			jQuery('div.model-window-inner a.close').click(function() {
				jQuery('div.model-window-outer').hide();
				return false;
			});
			jQuery('div.model-window-inner div.text').html(jQuery(modelText).html());
			jQuery('div.model-window-outer').show();
		}
		return false;
	});
	jQuery('a#display_gm_direct').click(function() {
		setTimeout(function () {
			GoogleMapsLoader.init();
		}, 400);
	});
	jQuery('section.visual_booking select').selectBox();
	jQuery('div#to_google_maps_map').click(function() {
		jQuery('a#display_gm_direct').trigger('click');
		jQuery('html, body').animate({scrollTop:jQuery('a#display_gm_direct').offset().top -165 }, 500);
		return false;
	});
	jQuery('.mobile_menu.button').click(function(e) {
		e.preventDefault();
		e.stopPropagation();
	   	jQuery('nav.mobile_menu').slideToggle();
		jQuery('nav.mobile_menu').css('top', (jQuery(document).scrollTop()+60) + 'px');
	   	return false;
	});
}
jQuery(document).ready(function(){
	wwdev.Bootstrap.runOnReady();
});
jQuery(window).on('load',function(){
	wwdev.Bootstrap.runOnLoad();
});

